import axios from "axios";

const apiCommons = axios.create({
  baseURL: process.env.REACT_APP_BOVEXO_COMMONS_URL,
  validateStatus: (status) => status >= 200 && status < 300,
  // baseURL: "http://localhost:8083",
});

export default apiCommons;
